import CIMSBasicFields from 'components/CIMSBasicFields'
import { HelpMessage } from 'utils/constants'
import { useIFINotificationsContext } from '../../../IFINotificationsContext'
import { DailyItem, FrequencyItem, IFINotificationEvent } from 'shared'
import { CIMSBasicFieldProps } from 'components/CIMSBasicFields/types'

const help = HelpMessage.IdentifiedFieldIssues.Notifications

const FrequencyFields: React.VFC = () => {
  const { notifications } = useIFINotificationsContext()
  const notification = notifications.find(
    ({ notificationEventId }) =>
      notificationEventId === IFINotificationEvent.IssueSummarized.id
  )
  const frequency = notification?.frequency
  const frequencyLabel = FrequencyItem.find(
    ({ type }) => type === frequency?.__typename
  )?.label
  const valueFields: CIMSBasicFieldProps[] = []
  if (frequency?.__typename === FrequencyItem.MinuteFrequencyItem.type)
    valueFields.push({
      label: 'Every',
      help: help.Time(frequency?.__typename),
      children: `${frequency?.minutes} minutes`,
    })
  else if (frequency?.__typename === FrequencyItem.HourlyFrequencyItem.type)
    valueFields.push({
      label: 'Every',
      help: help.Time(frequency?.__typename),
      children: `${frequency?.hours} hours`,
    })
  else if (
    frequency?.__typename === FrequencyItem.DailyFrequencyItem.type ||
    frequency?.__typename === FrequencyItem.WeeklyFrequencyItem.type
  ) {
    const hour = frequency?.hour % 12 || 12
    const minute = frequency?.minute.toString().padStart(2, '0')
    const amOrPm = frequency?.hour < 12 ? 'am' : 'pm'
    if (frequency?.__typename === FrequencyItem.WeeklyFrequencyItem.type)
      valueFields.push({
        label: 'On',
        help: help.Day,
        children: DailyItem.fromValue(frequency.day)?.label,
      })
    valueFields.push({
      label: 'At',
      help: help.Time(frequency?.__typename),
      children: `${hour}:${minute} ${amOrPm}`,
    })
  }

  return (
    <CIMSBasicFields
      fields={[
        {
          label: 'Frequency',
          help: help.Frequency(frequency?.__typename),
          children: frequencyLabel,
        },
        ...valueFields,
      ]}
    />
  )
}

export default FrequencyFields
